import { render, staticRenderFns } from "./training-importer-page.vue?vue&type=template&id=40a94ccd&"
import script from "./training-importer-page.vue?vue&type=script&lang=js&"
export * from "./training-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports